export default {
  rolePos: {
    ROLE_IT: '機関管理者',
    ROLE_AGENT: '代理店管理者',
  },
  booleanOptions: {
    YES: 'はい',
    NO: 'いいえ',
  },
};
